if (!customElements.get('product-upsell')) {
    customElements.define('product-upsell', class ProductUpsell extends HTMLElement {
        constructor(){
            super()
            this.money_format = this.dataset.moneyFormat
            this.upsellEl = this.querySelector('.product-upsell')

            // this.addEventListener('change', this.updateVariantInput.bind(this))
            this.addEventListener('change', this.handleUpsellClick.bind(this))
        }

        handleUpsellClick(e) {
            var upsell_item;

            if(e.target.classList.contains('upsell__toggle')) {
                console.log("TOGGLE")
                //main upsell toggle checked
                let container_el = e.target.parentNode
                let id = e.target.id
                let is_checked = e.target.checked

                upsell_item = container_el.querySelector(`.product-upsell__item[for="${id}"]`)
                if(!upsell_item) return

                const variant_select = upsell_item.querySelector('select')

                if(upsell_item.dataset.onlyDefault == "false") {
                    //has multiple variants ie// has select
                    if(!is_checked) {
                        upsell_item.classList.remove('product-upsell__item--selected') 
                        if(variant_select) {
                            //reset select
                            variant_select.querySelectorAll('option')[0].selected = 'selected'

                            const price_el = upsell_item.querySelector('.upsell-price.upsell-price--variant')
                            const og_price_el = upsell_item.querySelector('.upsell-price.upsell-price--original')
                            const variant_el = upsell_item.querySelector('.variant')

                            og_price_el.classList.add('in-view')
                            price_el.classList.remove('in-view')

                            //re-calc total price
                            upsell_item.dataset.currentPrice = 0
                            this.setTotalPrice()

                            if(variant_el) {
                                variant_el.innerHTML = ""
                            }
                        }
                    } else {
                        //show select, therefore dont run updateVariantInput
                        return
                    }
                } else {
                    //non select upsell
                    if(!is_checked) {
                        //disabled
                        upsell_item.dataset.currentPrice = 0
                        this.setTotalPrice()
                        // return
                    }
                }
            } else {
                //made choice of variant (select element)
                upsell_item = e.target.closest('.product-upsell__item')
                if(!upsell_item) return

                upsell_item.classList.add('product-upsell__item--selected') //css controls display of variant select
            }

            this.updateVariantInput(upsell_item) //always call to clear or create variant id
            
        }

        getUpsellData() {
            this.upsellData = this.upsellData || JSON.parse(this.querySelector('[type="application/json"]').textContent)

            return this.upsellData
        }

        //returns matched upsell variant data from given upsell-item
        getCurrentSetForm(upsell_item) {
            const form_el = upsell_item.querySelector('.product-upsell__form')

            if(!form_el) return

            this.getUpsellData()

            if(!this.upsellData) return

            const clicked_product_data = this.upsellData[parseInt(upsell_item.dataset.index)]

            if(!clicked_product_data) return

            return this.setFormData(form_el, clicked_product_data, upsell_item)
        }

        setFormData(form, data, item) {
            const price_el = item.querySelector('.upsell-price.upsell-price--variant')
            const og_price_el = item.querySelector('.upsell-price.upsell-price--original')
            const variant_el = item.querySelector('.variant')
            const form_input = form.querySelector('select') || form.querySelector('input')

            if(!form_input) return false

            const variant_id = form_input.value

            var variant_object = data.find(variant => variant.id == variant_id)

            if(!variant_object) return false

            if(og_price_el && og_price_el.classList.contains('in-view')) {
                og_price_el.classList.remove('in-view')
            }
            if(price_el && !price_el.classList.contains('in-view')) {
                price_el.classList.add('in-view')
            }
            // price_el.innerHTML = money.format(variant_object.price/100)
            price_el.innerHTML = Shopify.formatMoney(variant_object.price, this.money_format) 

            //attach raw price to data tag and re-calc total price
            item.dataset.currentPrice = variant_object.price
            this.setTotalPrice()

            if(item.dataset.onlyDefault == "false") {
                variant_el.innerHTML = " - " +  variant_object.title
            } else {
                variant_el.innerHTML = ""
            }

            return variant_id

        } 

        showUpsellForm(item) {
            this.closeCurrentUpsell()
            this.upsellEl.classList.add('active')
            item.classList.add('in-view')
        }

        //Creates secondary input to add 2 products to cart
        updateVariantInput(upsell_item) {
            // const upsell_item = e.target.closest('.product-upsell__item')
            // if(!upsell_item) return

            const variant_id = this.getCurrentSetForm(upsell_item)

            if(!variant_id) return

            const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);

            productForms.forEach((productForm) => {
                
                const input = productForm.querySelector('input[name="id"]');

                if(input) {
                    //set single input to array-obj style
                    input.name = "items[0][id]";

                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }

                const selected_index = upsell_item.dataset.index
                const upsell_input = productForm.querySelector(`input[name="items[${parseInt(selected_index) + 1}][id]"]`)

                if(upsell_input) {
                    // already has upsell, change variant ID
                    upsell_input.remove()

                } else {
                    let new_upsell_input = document.createElement('input')
                    new_upsell_input.type = "hidden"
                    new_upsell_input.name = `items[${parseInt(selected_index) + 1}][id]`
                    new_upsell_input.value = variant_id
                    productForm.append(new_upsell_input)

                }
                // input.value = this.currentVariant.id;
                // input.dispatchEvent(new Event('change', { bubbles: true }));

                /*

                TODO
                    - Out of stock upsell, don't add
                    - Remove product, remove hidden input
                */
            });
        }

        closeCurrentUpsell() {
            const current_inview = this.querySelector('.product-upsell__item.in-view')

            if(current_inview){
                current_inview.classList.remove('in-view')
            }

            this.upsellEl.classList.remove('active')
        }

        //iterate over all upsell__items and calculate total price
        setTotalPrice() {
            
            const all_items = this.querySelectorAll('.product-upsell__item')
            const total_price = Array.from(all_items).reduce((accum, item) => {
                var item_price = parseInt(item.dataset.currentPrice) || 0
                return accum + item_price
            }, 0)

            const price_total = this.querySelector('.upsell-total-price')

            const price_copy = total_price > 0 ? `+ ${Shopify.formatMoney(total_price, this.money_format) }` : ''

            price_total.innerHTML = price_copy
        }
    })
}